
const state = {
  artwork_email: '',
  booking_api: '',
  booking_email: '',
  day_published: '',
  deadlines: {},
  editorial_email: '',
  email: '',
  features: {
    editorial: false,
    ofi: false,
  },
  ftp_host: '',
  ftp_password: '',
  ftp_path: '',
  ftp_port: '',
  ftp_username: '',
  id: null,
  instructions: '',
  ofi_email: '',
  options: {
    accept_bookings_after_deadline: true,
    allow_user_revert: false,
    booking_api_mode: '',
    booking_confirmation_id_method: '',
    cancellation_api_enabled: false,
    deadline_version: 'V1',
    disable_preflight: false,
    file_transfer_protocol: '',
    inspection_format: '',
    sftp_login_details: {
      host: '',
      password: '',
      path: '',
      username: '',
    },
  },
  page_rows: '',
  page_columns: '',
  provider_id: undefined,
  provider_price_list_id: undefined,
  publication_identifier: '',
  time_zone: 'Australia/Sydney',
  title: '',
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'title' },
]

export default state
